import { useState } from "react";
import { uploadMedia } from "../../../../api/apiServices";
import mediaCategories from "../../../../constants/mediaCategories";

export default function MediaUpload({ onUploadSuccess }) {
  const [category, setCategory] = useState("");
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files);
    setFiles(selected);
    setPreviews(selected.map((file) => URL.createObjectURL(file)));
  };

  const handleUpload = async () => {
    if (!category || files.length === 0) return;

    const formData = new FormData();
    formData.append("category", category);
    files.forEach((file) => formData.append("files", file));

    try {
      setLoading(true);
      await uploadMedia(formData);
      setFiles([]);
      setPreviews([]);
      setCategory("");
      onUploadSuccess();
    } catch (err) {
      console.error("Upload failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-2xl shadow mb-8 border border-slate-200">
      <h2 className="text-lg font-semibold mb-4">Upload Media</h2>

      <div className="flex flex-col sm:flex-row items-center gap-4">
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="border border-slate-300 rounded-lg px-4 py-2 w-full sm:w-64"
        >
          <option value="">Select Category</option>
          {mediaCategories.map((cat) => (
            <option key={cat.value} value={cat.value}>
              {cat.label}
            </option>
          ))}
        </select>

        <input
          type="file"
          multiple
          onChange={handleFileChange}
          accept="image/*,video/*"
          className="border border-slate-300 rounded-lg px-4 py-2 w-full sm:w-64"
        />

        <button
          onClick={handleUpload}
          disabled={!files.length || !category || loading}
          className={`${
            loading
              ? "bg-slate-400 cursor-not-allowed"
              : "bg-emerald-600 hover:bg-emerald-700"
          } text-white px-6 py-2 rounded-lg transition`}
        >
          {loading ? "Uploading..." : "Upload"}
        </button>
      </div>

      {previews.length > 0 && (
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
          {previews.map((src, idx) => (
            <div key={idx} className="relative group">
              {files[idx].type.startsWith("video/") ? (
                <video
                  src={src}
                  className="rounded-lg w-full h-32 object-cover"
                  controls
                />
              ) : (
                <img
                  src={src}
                  alt="preview"
                  className="rounded-lg w-full h-32 object-cover"
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
